export default __webpack_public_path__ + "static/media/icon-notifications-color-gray-dark.7fafcd5a.svg";